<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="tabsClick" v-model="tabVal">
      <el-tab-pane
        v-for="item in REWARD_TYPE"
        :key="item.key"
        :name="item.key + ''"
        :label="item.value"
        v-loading="listLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="#e6ebf54d"
      >
        <el-form
          :inline="true"
          ref="form"
          label-width="250px"
          style="width: 100%;min-height: calc(100vh - 200px);"
        >
          <el-row :gutter="10">
            <!--              状态-->
            <el-col :xs="24" :sm="16" :xl="16">
              <el-form-item label="状态">
                <el-switch
                  v-model="settingData.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8" :xl="8" style="text-align: right">
              <el-button type="primary" v-show="!isEdit" @click="isEdit = true">编辑</el-button>
              <el-button type="success" v-show="isEdit" @click="saveOk" :loading="btnLoading"
                >保存</el-button
              >
            </el-col>
          </el-row>
          <!--          直推-->
          <div v-if="REWARD_TYPE_.DIRECT_THRUST === settingData.type && settingData.status">
            <template v-if="settingData.rewardRule.length !== 0">
              <el-card
                shadow="hover"
                :style="{
                  'margin-bottom': '20px',
                  border: '1px solid #3479b73d'
                }"
                v-for="(trItem, trIndex) in settingData.rewardRule"
                :key="trIndex"
              >
                <div
                  slot="header"
                  class="clearfix"
                  :style="{
                    'background-color': '#3479b73d'
                  }"
                >
                  <span>推荐的第{{ trIndex + 1 }}个人</span>
                </div>
                <el-row v-for="(cItem, cIndex) in trItem" :key="cIndex" :gutter="10">
                  <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                    <el-form-item label="账户类别">
                      <span v-show="!isEdit">{{ getValue(ACCOUNT_CATEGORY, cItem.category) }}</span>
                      <el-select
                        v-model="cItem.category"
                        placeholder="请选择"
                        class="filter-item"
                        clearable
                        size="small"
                        v-show="isEdit"
                        v-el-select-loadmore="loadMore(rangeNumber)"
                      >
                        <el-option
                          v-for="o in ACCOUNT_CATEGORY.slice(0, rangeNumber)"
                          :key="o.key"
                          :label="o.value"
                          :value="o.key"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                    <el-form-item label="账户类型">
                      <span v-show="!isEdit">{{ getValue(ACCOUNT_TYPE, cItem.type) }}</span>
                      <el-select
                        v-model="cItem.type"
                        placeholder="请选择"
                        class="filter-item"
                        clearable
                        size="small"
                        v-show="isEdit"
                        v-el-select-loadmore="loadMore(rangeNumber)"
                      >
                        <el-option
                          v-for="o in ACCOUNT_TYPE.slice(0, rangeNumber)"
                          :key="o.key"
                          :label="o.value"
                          :value="o.key"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                    <el-form-item label="赠送直推下线消费金额的百分比">
                      <span v-if="!isEdit">{{ cItem.rate }}</span>
                      <el-input v-model="cItem.rate" placeholder="请输入" size="small" v-else />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="3" :xl="3">
                    <el-button
                      type="danger"
                      plain
                      size="medium"
                      @click="deleteCTZ(trIndex, cIndex)"
                      v-if="isEdit"
                      >删除</el-button
                    >
                  </el-col>
                  <el-col :xs="24" :sm="24" :xl="24">
                    <div class="fg_comm"></div>
                  </el-col>
                </el-row>
                <div style="text-align: right">
                  <el-button
                    type="success"
                    plain
                    style="width: calc(100% - 150px)"
                    size="medium"
                    @click="addCTZ(trIndex)"
                    v-if="isEdit"
                    >添加账户</el-button
                  >
                </div>
              </el-card>
            </template>
          </div>
          <el-button
            type="primary"
            plain
            style="width: calc(100% - 0px)"
            size="medium"
            @click="addZT"
            v-if="isEdit && settingData.status && REWARD_TYPE_.DIRECT_THRUST === settingData.type"
            >添加</el-button
          >
          <div
            class="zt_msg"
            v-if="REWARD_TYPE_.DIRECT_THRUST === settingData.type && settingData.status"
          >
            注：推荐的第{{ settingData.rewardRule.length }}个以后的人延用第{{
              settingData.rewardRule.length
            }}个人的配置
          </div>

          <!--          平级-->
          <el-row
            :gutter="10"
            v-if="REWARD_TYPE_.PARALLEL_GRADE === settingData.type && settingData.status"
          >
            <template v-if="settingData.rewardRule.length !== 0">
              <div v-for="(trItem, trIndex) in settingData.rewardRule" :key="trIndex">
                <el-col :xs="24" :sm="12" :xl="12">
                  <el-form-item label="账户类别">
                    <span v-show="!isEdit">{{ getValue(ACCOUNT_CATEGORY, trItem.category) }}</span>
                    <el-select
                      v-model="trItem.category"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-show="isEdit"
                      v-el-select-loadmore="loadMore(rangeNumber)"
                    >
                      <el-option
                        v-for="o in ACCOUNT_CATEGORY.slice(0, rangeNumber)"
                        :key="o.key"
                        :label="o.value"
                        :value="o.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="12">
                  <el-form-item label="账户类型">
                    <span v-show="!isEdit">{{ getValue(ACCOUNT_TYPE, trItem.type) }}</span>
                    <el-select
                      v-model="trItem.type"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-show="isEdit"
                      v-el-select-loadmore="loadMore(rangeNumber)"
                    >
                      <el-option
                        v-for="o in ACCOUNT_TYPE.slice(0, rangeNumber)"
                        :key="o.key"
                        :label="o.value"
                        :value="o.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="12">
                  <el-form-item label="直推赠送基数金额">
                    <span v-if="!isEdit">{{ trItem.ztAmount }}</span>
                    <el-input v-model="trItem.ztAmount" placeholder="请输入" size="small" v-else />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="12">
                  <el-form-item label="直推赠送百分比">
                    <span v-if="!isEdit">{{ trItem.ztRate }}</span>
                    <el-input v-model="trItem.ztRate" placeholder="请输入" size="small" v-else />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="12">
                  <el-form-item label="间推赠送基数金额">
                    <span v-if="!isEdit">{{ trItem.jtAmount }}</span>
                    <el-input v-model="trItem.jtAmount" placeholder="请输入" size="small" v-else />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="12">
                  <el-form-item label="间推赠送百分比">
                    <span v-if="!isEdit">{{ trItem.jtRate }}</span>
                    <el-input v-model="trItem.jtRate" placeholder="请输入" size="small" v-else />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :xl="24" style="text-align: right">
                  <el-button
                    type="danger"
                    plain
                    size="medium"
                    @click="deleteTr(REWARD_TYPE_.PARALLEL_GRADE, trIndex)"
                    style="width: calc(100% - 150px)"
                    v-if="isEdit"
                    >删除</el-button
                  >
                </el-col>
                <el-col :xs="24" :sm="24" :xl="24">
                  <div class="fg_comm"></div>
                </el-col>
              </div>
            </template>
            <el-col :xs="24" :sm="24" :xl="24" style="text-align: right">
              <el-button
                type="success"
                plain
                style="width: calc(100% - 150px)"
                size="medium"
                @click="addTr(REWARD_TYPE_.PARALLEL_GRADE)"
                v-if="isEdit"
                >添加</el-button
              >
            </el-col>
          </el-row>

          <!--          间推-->
          <el-row
            :gutter="10"
            v-if="settingData.status && REWARD_TYPE_.GRADUALLY_THRUST === settingData.type"
          >
            <el-col :xs="24" :sm="24" :xl="24">
              <el-form-item label="奖励追溯层级">
                <span v-if="!isEdit">{{ settingData.rewardRule.depth }}</span>
                <el-input
                  v-model="settingData.rewardRule.depth"
                  placeholder="请输入"
                  size="small"
                  v-else
                />
              </el-form-item>
            </el-col>
            <template v-if="REWARD_TYPE_.GRADUALLY_THRUST === settingData.type">
              <div v-for="(trItem, trIndex) in settingData.rewardRule.accts" :key="trIndex">
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="账户类别">
                    <span v-show="!isEdit">{{ getValue(ACCOUNT_CATEGORY, trItem.category) }}</span>
                    <el-select
                      v-model="trItem.category"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-show="isEdit"
                      v-el-select-loadmore="loadMore(rangeNumber)"
                    >
                      <el-option
                        v-for="o in ACCOUNT_CATEGORY.slice(0, rangeNumber)"
                        :key="o.key"
                        :label="o.value"
                        :value="o.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="账户类型">
                    <span v-show="!isEdit">{{ getValue(ACCOUNT_TYPE, trItem.type) }}</span>
                    <el-select
                      v-model="trItem.type"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-show="isEdit"
                      v-el-select-loadmore="loadMore(rangeNumber)"
                    >
                      <el-option
                        v-for="o in ACCOUNT_TYPE.slice(0, rangeNumber)"
                        :key="o.key"
                        :label="o.value"
                        :value="o.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                  <el-form-item label="赠送下线获得金额的百分比">
                    <span v-if="!isEdit">{{ trItem.rate }}</span>
                    <el-input v-model="trItem.rate" placeholder="请输入" size="small" v-else />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="3" :xl="3">
                  <el-button
                    type="danger"
                    plain
                    size="medium"
                    @click="deleteTr(REWARD_TYPE_.GRADUALLY_THRUST, trIndex)"
                    v-if="isEdit"
                    >删除</el-button
                  >
                </el-col>
                <el-col :xs="24" :sm="24" :xl="24">
                  <div class="fg_comm"></div>
                </el-col>
              </div>
            </template>
            <el-col :xs="24" :sm="24" :xl="24" style="text-align: right">
              <el-button
                type="success"
                plain
                style="width: calc(100% - 150px)"
                size="medium"
                @click="addTr(REWARD_TYPE_.GRADUALLY_THRUST)"
                v-if="isEdit"
                >添加</el-button
              >
            </el-col>
          </el-row>
          <!--          极差-->
          <el-row :gutter="10" v-if="settingData.status && REWARD_TYPE_.RANGE === settingData.type">
            <div v-for="(trItem, trIndex) in settingData.rewardRule" :key="trIndex">
              <el-col :xs="24" :sm="itemSm" :xl="itemXl">
                <el-form-item label="账户类别">
                  <span v-show="!isEdit">{{ getValue(ACCOUNT_CATEGORY, trItem.category) }}</span>
                  <el-select
                    v-model="trItem.category"
                    placeholder="请选择"
                    class="filter-item"
                    clearable
                    size="small"
                    v-show="isEdit"
                    v-el-select-loadmore="loadMore(rangeNumber)"
                  >
                    <el-option
                      v-for="o in ACCOUNT_CATEGORY.slice(0, rangeNumber)"
                      :key="o.key"
                      :label="o.value"
                      :value="o.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="3" :xl="3">
                <el-button
                  type="danger"
                  plain
                  size="medium"
                  @click="deleteTr(REWARD_TYPE_.RANGE, trIndex)"
                  v-if="isEdit"
                  >删除</el-button
                >
              </el-col>
              <el-col :xs="24" :sm="24" :xl="24">
                <div class="fg_comm"></div>
              </el-col>
            </div>
            <el-col :xs="24" :sm="24" :xl="24" style="text-align: right">
              <el-button
                type="success"
                plain
                style="width: calc(100% - 150px)"
                size="medium"
                @click="addTr(REWARD_TYPE_.RANGE)"
                v-if="isEdit"
                >添加</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getRewardDetail,
  editSameGrade,
  editZhitui,
  editJiantui,
  editIntervalGrade
} from "@/api/system.js";
import {
  getValue,
  REWARD_TYPE,
  REWARD_TYPE_,
  ACCOUNT_CATEGORY,
  ACCOUNT_TYPE
} from "@/utils/enumUtile";
import { toFixedNumFun } from "@/utils";

export default {
  name: "index",
  computed: {
    REWARD_TYPE() {
      return REWARD_TYPE;
    },
    REWARD_TYPE_() {
      return REWARD_TYPE_;
    },
    ACCOUNT_CATEGORY() {
      return ACCOUNT_CATEGORY;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      listLoading: false,
      tabVal: null,
      categoryNames: [],
      isEdit: false,
      btnLoading: false,
      settingData: {},
      rangeNumber: 10,
      itemSm: 7,
      itemXl: 7
    };
  },
  created() {
    const type = REWARD_TYPE[0].key;
    this.getList(type);
  },
  watch: {},
  methods: {
    getValue,
    loadMore(n) {
      // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数  可自定义
    },
    /**
     * 查询用户列表
     */
    getList(type) {
      this.tabVal = type + "";
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const params = {
        type
      };
      getRewardDetail(params)
        .then(response => {
          let data = {};
          if (response && response.bizcode === 100) {
            data = response.data;
            if (data && data.rewardRule) {
              data.rewardRule = this.handleRewardRule(
                JSON.parse(data.rewardRule),
                data.type,
                "find"
              );
            } else {
              data.rewardRule =
                parseInt(type, 10) === REWARD_TYPE_.GRADUALLY_THRUST
                  ? {
                      depth: null,
                      accts: []
                    }
                  : [];
            }
            data.status = data.status === 1 ? true : false;
          }
          this.settingData = data;
        })
        .finally(() => {
          loading.close();
        });
    },
    /**
     * tab 切换
     * @param e
     */
    async tabsClick(e) {
      this.isEdit = false;
      this.settingData = {};
      this.getList(e.name);
    },
    /**
     * 处理奖励规则
     * @param data
     * @param type
     */
    handleRewardRule(data, type, handle) {
      if (!data && data === 0) {
        return [];
      }
      const currentData = data;
      const currentType = parseInt(type, 10);
      // 直推
      if (currentType === REWARD_TYPE_.DIRECT_THRUST) {
        currentData.map(item => {
          item.map(cItem => {
            if (handle === "update" && cItem.rate) {
              cItem.rate = toFixedNumFun(cItem.rate, "save");
            }
            if (handle === "find" && cItem.rate) {
              cItem.rate = cItem.rate * 100;
            }
          });
        });
      }
      // 平级
      if (currentType === REWARD_TYPE_.PARALLEL_GRADE) {
        currentData.map(item => {
          if (handle === "update" && item.ztRate) {
            item.ztRate = toFixedNumFun(item.ztRate, "save");
          }
          if (handle === "find" && item.ztRate) {
            item.ztRate = toFixedNumFun(item.ztRate, "info");
          }
          if (handle === "update" && item.jtRate) {
            item.jtRate = toFixedNumFun(item.jtRate, "save");
          }
          if (handle === "find" && item.jtRate) {
            item.jtRate = toFixedNumFun(item.jtRate, "info");
          }
        });
      }
      // 间推
      if (currentType === REWARD_TYPE_.GRADUALLY_THRUST) {
        if (currentData.accts) {
          currentData.accts.map(item => {
            if (handle === "update" && item.rate) {
              item.rate = toFixedNumFun(item.rate, "save");
            }
            if (handle === "find" && item.rate) {
              item.rate = toFixedNumFun(item.rate, "info");
            }
          });
        } else {
          currentData.accts = [];
        }
      }
      // 极差
      if (currentType === REWARD_TYPE_.RANGE) {
      }
      return currentData;
    },
    /**
     * 保存
     */
    async saveOk() {
      const selTab = parseInt(this.tabVal, 10);
      const settingData = this.settingData;
      const rewardRule = this.handleRewardRule(settingData.rewardRule, selTab, "update");
      const params = {
        status: settingData.status ? 1 : 0,
        rewardRule: JSON.stringify(rewardRule)
      };
      let resp = null;
      if (selTab === REWARD_TYPE_.DIRECT_THRUST) {
        // 直推
        resp = await editZhitui(params);
      } else if (selTab === REWARD_TYPE_.PARALLEL_GRADE) {
        // 平级
        resp = await editSameGrade(params);
      } else if (selTab === REWARD_TYPE_.GRADUALLY_THRUST) {
        // 间推
        resp = await editJiantui(params);
      } else if (selTab === REWARD_TYPE_.RANGE) {
        // 极差
        resp = await editIntervalGrade(params);
      }
      if (resp && resp.bizcode === 100) {
        this.isEdit = false;
        this.getList(selTab);
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
          duration: 2000
        });
      }
    },
    /**
     * 添加账户相互转换的item
     * @param index
     */
    addTr(type) {
      const data = this.settingData.rewardRule;
      // 平级
      if (type === REWARD_TYPE_.PARALLEL_GRADE) {
        data.push({
          category: null,
          type: null,
          ztAmount: null,
          ztRate: null,
          jtAmount: null,
          jtRate: null
        });
      }
      // 间推
      if (type === REWARD_TYPE_.GRADUALLY_THRUST) {
        data.accts.push({
          category: null,
          type: null,
          rate: null
        });
      }
      // 极差
      if (type === REWARD_TYPE_.RANGE) {
        data.push({
          category: null
        });
      }
      console.log("data", data);
      this.settingData.rewardRule = data;
    },
    /**
     * 删除账户相互转换的item
     * @param type
     * @param index
     */
    deleteTr(type, cIndex) {
      // 平级 and 极差
      if ([REWARD_TYPE_.PARALLEL_GRADE, REWARD_TYPE_.RANGE].includes(type)) {
        this.settingData.rewardRule.splice(cIndex, 1);
      }
      // 间推
      if (type === REWARD_TYPE_.GRADUALLY_THRUST) {
        this.settingData.rewardRule.accts.splice(cIndex, 1);
      }
    },
    /**
     * 直推荐最外层
     */
    addZT() {
      const rewardRule = this.settingData.rewardRule;
      rewardRule.push([
        {
          category: null,
          type: null,
          rate: null
        }
      ]);
      this.settingData.rewardRule = rewardRule;
    },

    /**
     * 直推的子集
     */
    addCTZ(pIndex) {
      const rewardRule = this.settingData.rewardRule[pIndex];
      rewardRule.push({
        category: null,
        type: null,
        rate: null
      });
      this.settingData.rewardRule[pIndex] = rewardRule;
    },
    deleteCTZ(trIndex, cIndex) {
      this.settingData.rewardRule[trIndex].splice(cIndex, 1);
    }
  },
  directives: {
    "el-select-loadmore": (el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) binding.value();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fg_comm {
  width: 100%;
  margin: 10px 0 20px;
  border: 1px dashed #eeeeee;
}
::v-deep .el-card__header {
  padding: 0px;
}
.clearfix {
  padding: 14px 20px;
}
.zt_msg {
  text-align: center;
  color: red;
  margin-top: 10px;
  font-size: 14px;
}
</style>
